export type PlayerTemplateId = 'agile' | 'economy' | 'burst';

export interface PlayerTemplateModifiers {
  moveSpeedMultiplier: number;
  pickupRadiusMultiplier: number;
  materialGainMultiplier: number;
  rerollDiscount: number;
  maxHpDelta: number;
  partnerDamageMultiplier: number;
  critChanceBonus: number;
}

export interface PlayerTemplateDefinition {
  id: PlayerTemplateId;
  name: string;
  subtitle: string;
  color: number;
  strokeColor: number;
  summary: string;
  weakness: string;
  modifiers: PlayerTemplateModifiers;
}

export const DEFAULT_PLAYER_TEMPLATE_ID: PlayerTemplateId = 'agile';

export const PLAYER_TEMPLATES: readonly PlayerTemplateDefinition[] = [
  {
    id: 'agile',
    name: '机动型',
    subtitle: '快跑位，主动捡材料',
    color: 0x66b8ff,
    strokeColor: 0xc8ecff,
    summary: '移速 +30% / 拾取 +30%',
    weakness: '最大生命 -10',
    modifiers: {
      moveSpeedMultiplier: 1.3,
      pickupRadiusMultiplier: 1.3,
      materialGainMultiplier: 1,
      rerollDiscount: 0,
      maxHpDelta: -10,
      partnerDamageMultiplier: 1,
      critChanceBonus: 0,
    },
  },
  {
    id: 'economy',
    name: '经济型',
    subtitle: '多买多刷，后期成型',
    color: 0xf2c15c,
    strokeColor: 0xffefb8,
    summary: '材料 +30% / 刷新 -1',
    weakness: '最大生命 -5',
    modifiers: {
      moveSpeedMultiplier: 1,
      pickupRadiusMultiplier: 1,
      materialGainMultiplier: 1.3,
      rerollDiscount: 1,
      maxHpDelta: -5,
      partnerDamageMultiplier: 1,
      critChanceBonus: 0,
    },
  },
  {
    id: 'burst',
    name: '爆发型',
    subtitle: '清怪更快，更怕失误',
    color: 0xff6a5f,
    strokeColor: 0xffc6bf,
    summary: '伙伴伤害 +20% / 暴击 +10%',
    weakness: '最大生命 -15',
    modifiers: {
      moveSpeedMultiplier: 1,
      pickupRadiusMultiplier: 1,
      materialGainMultiplier: 1,
      rerollDiscount: 0,
      maxHpDelta: -15,
      partnerDamageMultiplier: 1.2,
      critChanceBonus: 0.1,
    },
  },
];

export function getPlayerTemplate(id: string | undefined): PlayerTemplateDefinition {
  if (!id) {
    return getDefaultPlayerTemplate();
  }

  const template = PLAYER_TEMPLATES.find((candidate) => candidate.id === id);
  if (!template) {
    throw new Error(`Unknown player template: ${id}`);
  }
  return template;
}

export function getDefaultPlayerTemplate() {
  return PLAYER_TEMPLATES.find((template) => template.id === DEFAULT_PLAYER_TEMPLATE_ID) ?? PLAYER_TEMPLATES[0];
}
